/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type BulkOrderActionRequest = {
    action: BulkOrderActionRequest.action;
    order_ids: Array<number>;
};
export namespace BulkOrderActionRequest {
    export enum action {
        MARK_PROCESSING = 'mark_processing',
        MARK_SHIPPED = 'mark_shipped',
        MARK_DELIVERED = 'mark_delivered',
    }
}

